import { useMemo } from "react"
import { type Currency, parseCurrency } from "../helpers/formatCurrencyBRL"

interface EnvVariables {
  geconturUrl: string | undefined
  apiUrl: string | undefined
  theme: string | undefined
  logo: string | undefined
  company: string | undefined
  currency: Currency
  isGea: boolean
  isGeaBrasil: boolean
  isGecontur: boolean
}

const useEnv = (): EnvVariables => {
  return useMemo(
    () => ({
      geconturUrl: import.meta.env.VITE_GECONTUR_URL,
      apiUrl: import.meta.env.VITE_API,
      theme: import.meta.env.VITE_THEME,
      logo: import.meta.env.VITE_LOGO,
      company: import.meta.env.VITE_COMPANY,
      currency: parseCurrency(import.meta.env.VITE_CURRENCY),
      isGea: import.meta.env.VITE_THEME === "gea",
      isGeaBrasil: import.meta.env.VITE_THEME === "geabrasil",
      isGecontur: import.meta.env.VITE_THEME === "gecontur",
    }),
    [],
  )
}

export default useEnv
